/**
 * Exposes methods that live on the window, that Zendesk has added
 */
export const useZendesk = () => {
    const showWindow = () => window.$zopim?.livechat.window.show();
    const showButton = () => window.$zopim?.livechat.button.show();
    const hideButton = () => window.$zopim?.livechat.button.hide();
    const setButtonOffsetVertical = (offset: number) =>
        window.$zopim?.livechat.button.setOffsetVertical(offset);
    return { showWindow, showButton, hideButton, setButtonOffsetVertical };
};
